import React, { useEffect, useContext, useState } from 'react';
import Select from '../../../components/Select';
import { GlobalDebtContext } from '../../../store';
import { useForm, Controller } from 'react-hook-form';
import { default as GlobalDebtTypes } from '../../../store/GlobalDebt/types';
import { getCreditById } from '../../../services/credit';
import { getExtracts } from '../../../services/extract';
import { getResidencesTypes } from '../../../services/residence';
import { getKinship } from '../../../services/kinship';
import { getEducational } from '../../../services/educational';
import { globalDebtSteps } from '../../../helpers/enum';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import FormTemplate from '../../../components/FormTemplate';
import { residenceTypes as residenceTypesEnum } from '../../../helpers/enum';
import InputDefault from '../../../components/InputDefault';
import Loader from '../../../components/LoaderDebt';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import { useLocation } from 'react-router-dom';

const BasicRequestInformationPage = ({ setActiveStep, setLastStep }) => {
  const location = useLocation();
  const { globalDebt, setGlobalDebt } = useContext(GlobalDebtContext);
  const { register, errors, control, setValue, clearErrors, handleSubmit } = useForm({ defaultValues: getDefaultValues() });
  const [extracts, setExtracts] = useState([]);
  const [showExtracts, setShowExtracts] = useState(false);
  const [residenceTypes, setResidenceTypes] = useState([]);
  const [showResidenceTypes, setShowResidenceTypes] = useState(false);
  const [kinship, setKinship] = useState([]);
  const [showKinship, setShowKinshi] = useState(false);
  const [educationalLevel, setEducationalLevel] = useState([]);
  const [showEducationalLevel, setShowEducationalLevel] = useState(false);
  const [housingClass, setHousingClass] = useState([]);
  const [showHousingClass, setShowHouseingClass] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  async function initializedStateComponent() {
    try {
      const extractResponse = await getExtracts();
      const housingClassResponse = await getResidencesTypes();
      const kinshipReponse = await getKinship();
      const educationalLevelReponse = await getEducational();
      await setExtracts(extractResponse.data);
      await setHousingClass(housingClassResponse.data);
      await setResidenceTypes(residenceTypesEnum);
      await setKinship(kinshipReponse.data);
      await setEducationalLevel(educationalLevelReponse.data);
      await autoCompleteData({
        extracts: extractResponse.data,
        residenceTypes: residenceTypesEnum,
        educationalLevel: educationalLevelReponse.data
      });

      setIsLoading(false);
    } catch (error) {

    }
  }

  function getDefaultValues() {
    return globalDebt.basicRequestInformation;
  }

  function autoCompleteData(data) {
    const estrato = globalDebt.solicitation.cliente.estrato;
    const tipoVivienda = globalDebt.basicRequestInformation.tipoVivienda.id || globalDebt.lastCredit.tipoVivienda;
    const nivelEscolaridad = globalDebt.solicitation.simulacion.nivelEducativo;
    if(estrato) {
      selectExtract((data.extracts.filter(e => e.idLegado === estrato) || data.extracts)[0]);
    }
    if(tipoVivienda) {
      selectResidenceType((data.residenceTypes.filter(rt => rt.id === tipoVivienda) || data.residenceTypes)[0]);
    }
    if(nivelEscolaridad) {
      selectEducationalLevel((data.educationalLevel.filter(el => el.idLegado === nivelEscolaridad) || data.educationalLevel)[0]);
    }
  }

  function setCompleteStep(data) {
    /*setGlobalDebt({
      type: GlobalDebtTypes.SET_BASIC_REQUEST_INFORMATION,
      adoSegmentCode: data.adoSegmentCode
    })*/
    setActiveStep(globalDebtSteps.FINANCE_DATA_ONE)
    setLastStep(globalDebtSteps.BASIC_REQUESTING_INFORMATION);
  }

  function selectExtract(extract) {
    console.log(extract)
    setValue("estrato", extract);
    clearErrors("estrato", {});

    setGlobalDebt({
      type: GlobalDebtTypes.SET_EXTRACT,
      estrato: extract
    })
  }

  function selectResidenceType(residenceType) {
    setValue("tipoVivienda", residenceType);
    clearErrors("tipoVivienda", {});

    setGlobalDebt({
      type: GlobalDebtTypes.SET_RESIDENCE_TYPE,
      tipoVivienda: residenceType
    })
  }

  function selectKinship(kinship) {
    setValue("posicionHogar", kinship);
    clearErrors("posicionHogar", {});

    setGlobalDebt({
      type: GlobalDebtTypes.SET_POSICION_HOGAR,
      posicionHogar: kinship
    })
  }

  function selectEducationalLevel(educationaLevel) {
    console.log(educationaLevel)
    setValue("nivelEscolaridad", educationaLevel);
    clearErrors("nivelEscolaridad", {});

    setGlobalDebt({
      type: GlobalDebtTypes.SET_EDUCATIONAL_LEVEL,
      nivelEscolaridad: educationaLevel
    })
  }

  function selectHousingClass(housingClass) {
    setValue("claseVivienda", housingClass);
    clearErrors("claseVivienda", {});

    setGlobalDebt({
      type: GlobalDebtTypes.SET_HOUSING_CLASS,
      claseVivienda: housingClass
    })
  }

  function selectSegment(segment) {
    setValue("segmento", segment);
    clearErrors("segmento", {});

    setGlobalDebt({
      type: GlobalDebtTypes.SET_SEGMENT,
      segmento: segment
    });
  }

  async function getCredit() {
    if(globalDebt.credit?.id && globalDebt.basicRequestInformation.segmento === '') {
      const segmentResponse = await getCreditById(location.idCredit);
      selectSegment(segmentResponse.data.segmento);
    } else if (globalDebt.lastCredit.segmento) {
      selectSegment(globalDebt.lastCredit.segmento);
    }
  }

  useEffect(() => {
    getCredit();
  }, [globalDebt])

  useEffect(() => {
    initializedStateComponent();

    return () => {
      setExtracts([]);
      setResidenceTypes([]);
      setKinship([]);
      setEducationalLevel([]);
      setHousingClass([]);
    }
  }, [])

  return (
    <FormTemplate 
      idForm="basic-request-information-step-page"
      activeStep="1/2"
      stepLabel="Información basica solicitante"
      idCredito={location.idCredit}>
      <Form onSubmit={handleSubmit(setCompleteStep)} id="form">
        <FormRow col="2">
          <Controller
            as={InputDefault}
            control={control}
            label="Segmento"
            name="segmento"
            register={register}
            id="segmento"
            error={errors.segmento}
            value={globalDebt.basicRequestInformation.segmento} 
            readOnly={true} />
           <Select
            error={errors.tipoVivienda}
            setShow={setShowResidenceTypes}
            show={showResidenceTypes}
            defaultValue={globalDebt.basicRequestInformation.tipoVivienda.nombre}
            setSelected={selectResidenceType}
            list={residenceTypes}
            placeholder="Seleccionar..."
            label="Tipo de vivienda"
            name="tipoVivienda"
            id="tipoVivienda"
            register={register({ required: "Este dato es obligatorio" })} />
        </FormRow> 
        <FormRow col="2">
          <Select
            error={errors.claseVivienda}
            setShow={setShowHouseingClass}
            show={showHousingClass}
            defaultValue={globalDebt.basicRequestInformation.claseVivienda.nombre}
            setSelected={selectHousingClass}
            list={housingClass}
            placeholder="Seleccionar..."
            label="Clase de vivienda"
            name="claseVivienda"
            id="claseVivienda"
            register={register({ required: "Este dato es obligatorio" })} />
            <Select
            error={errors.posicionHogar}
            setShow={setShowKinshi}
            show={showKinship}
            defaultValue={globalDebt.basicRequestInformation.posicionHogar.nombre}
            setSelected={selectKinship}
            list={kinship}
            placeholder="Seleccionar..."
            label="Posición en el hogar"
            name="posicionHogar"
            id="posicionHogar"
            register={register({ required: "Este dato es obligatorio" })} />
        </FormRow> 
        <FormRow style={{display: 'none'}}>
          <Select
            error={errors.estrato}
            setShow={setShowExtracts}
            show={showExtracts}
            defaultValue={globalDebt.basicRequestInformation.estrato.nombre}
            setSelected={selectExtract}
            list={extracts}
            placeholder="Seleccionar..."
            label="Estrato"
            name="estrato"
            id="estrato"
            register={register({ required: "Este dato es obligatorio" })} />
        <Select
            error={errors.nivelEscolaridad}
            setShow={setShowEducationalLevel}
            show={showEducationalLevel}
            defaultValue={globalDebt.basicRequestInformation.nivelEscolaridad.nombre}
            setSelected={selectEducationalLevel}
            list={educationalLevel}
            placeholder="Seleccionar..."
            label="Nível de escolaridad"
            name="nivelEscolaridad"
            id="nivelEscolaridad"
            register={register({ required: "Este dato es obligatorio" })}
            />
        </FormRow>
        <FormFooter justify="flex-end">
          <SecondaryLargeButton type="submit" id="submit">Siguiente </SecondaryLargeButton>
        </FormFooter>
        {isLoading && <Loader />}
      </Form>
    </FormTemplate>
  )
}

export default BasicRequestInformationPage;
